<template>
  <a-dialog v-model="show">
    <div slot="header" v-text="passwordResetSendLetter()" />
    <div slot="body" v-text="passwordResetSendLetterDescription()" />
    <div slot="footer">
      <button
        v-t="'Security.UserAdministration.PasswordResetAbort'"
        type="button"
        class="btn btn-pf-secondary mr-2"
        @click="$emit('input', false)"
      />
      <button
        v-t="'Security.UserAdministration.PasswordResetDownloadLetter'"
        type="button"
        class="btn btn-pf-primary"
        @click="generateLetter()"
      />
    </div>
  </a-dialog>
</template>

<script>
import fetch from "unfetch";
import Dialog from "+/components/dialog/Dialog";

export default {
  components: {
    "a-dialog": Dialog
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
      }
    }
  },
  methods: {
    generateLetter() {
      this.$emit("input", false);
      this.$rest.security
        .generatePasswordResetLetter(this.user.id)
        .then(response => {
          const { dokRefnr } = response.data;
          let filename = "password-reset.rtf";
          fetch(
            `${window.location.origin}/persis/main?fn=ma&action=pwd_change_doc_download&dok_refnr=${dokRefnr}`
          )
            .then(response => {
              for (var pair of response.headers.entries()) {
                if (pair[0] === "content-disposition") {
                  let filenameString = pair[1].split("filename=")[1];
                  filenameString = filenameString.replace('"', "");
                  filename = filenameString.replace('"', "");
                  break;
                }
              }

              return response.blob();
            })
            .then(response => {
              if (window.navigator.msSaveBlob) {
                //ie, edge
                window.navigator.msSaveOrOpenBlob(response, filename);
              } else {
                const url = window.URL.createObjectURL(response);
                const link = document.createElement("a");
                link.href = url;
                link.style.display = "none";
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }
            })
            .catch(this.generateLetterException);
        })
        .catch(this.generateLetterException);
    },
    generateLetterException() {
      const error = this.$t(
        "Security.UserAdministration.PasswordResetSendLetterException"
      );
      this.$feedback(error, { type: "error" });
    },
    passwordResetSendLetter() {
      return this.$t("Security.UserAdministration.PasswordResetSendLetter");
    },
    passwordResetSendLetterDescription() {
      return this.$t(
        "Security.UserAdministration.PasswordResetSendLetterDescription"
      );
    }
  }
};
</script>
